import { service, base, } from './app.service';
import UpsellModel from '@/models/UpsellModel';
import Promise from 'ts-promise';
import { each, flatMap, compact } from 'lodash';
import locationService from '@/services/location.service';
var storedLocation = locationService.getLocationFromStorage();
var locationBase = base;
if (storedLocation && storedLocation.id) {
    locationBase = storedLocation.id;
}
var endpoints = {
    GET_ALL: "/admin/squib_get_upsell?b=" + locationBase,
    UPDATE: function (id, action) { return "/admin/do_edit_upsell?b=" + locationBase + "&upsell_id=" + id + "&action=" + action; },
};
var upsells = [];
var upsellService = {
    fetchAllUpsells: function (callback) {
        return service.get(endpoints.GET_ALL).then(function (response) {
            var upsellMap = response.data.body;
            each(upsellMap, function (_upsell) {
                var upsell = new UpsellModel(_upsell);
                upsells.push(upsell);
            });
            if (callback) {
                callback(upsells);
            }
        }).catch(function (error) {
            console.error("Error fetching upsells: " + error);
        });
    },
    getUpsells: function () {
        return new Promise(function (resolve) {
            if (upsells.length === 0) {
                upsellService.fetchAllUpsells(function (data) {
                    upsells = data;
                    resolve(upsells);
                });
            }
            else {
                resolve(upsells);
            }
        });
    },
    updateUpsell: function (id, action) {
        service.post(endpoints.UPDATE(id, action));
    },
    checkUpsellConversions: function (items, vue) {
        if (upsells.length === 0) {
            return;
        }
        var upsellIds = flatMap(items, function (item) {
            return item.getUpsellDiscount();
        });
        upsellIds = compact(upsellIds);
        each(upsellIds, function (id) {
            var action = 'conversion';
            upsellService.updateUpsell(id, action);
            vue.$tpa.trackCartUpsell("id: " + id + " - action: " + action);
        });
    },
};
export default upsellService;



//////////////////
// WEBPACK FOOTER
// ./src/services/upsell.service.ts
// module id = null
// module chunks = 